import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchSetupAuditTrailViewRequest = {
	advanceFilter?: string;
	filter?: string;
	name?: string;
	ordering?: string;
	viewId: number;
};

export const patchSetupAuditTrailViews = createPatchEndpoint<PatchSetupAuditTrailViewRequest>(
	({ viewId }) => `/api/v3/setup-audit-trail/views/${viewId}`
);
